import { createContext, useContext } from "react";
import { useStore } from "zustand";
import type { MessageState, MessageStore } from "./store";

export const MessageContext = createContext<MessageStore | null>(null);

export const useMessageContext = <T>(
	selector: (state: MessageState) => T,
): T => {
	const storeContext = useContext(MessageContext);
	if (!storeContext)
		throw new Error("Missing MessageContext.Provider in the tree");
	return useStore(storeContext, selector);
};
